
//Functions for uses amounst the application


//Parses panel location string to readable format for layman understanding
export function parseLocationString(str) {
    const regex = /^IB(\d+)-G(\d+)-R(\d+)N-C(\d+)W$/;
    const match = str.match(regex);

    if (!match) return null;

    const [, ib, group, row, col] = match;
    return {
        ib,
        group,
        row,
        col,
    };
}